import React from 'react'
import LoaderButton from '../../components/LoaderButton'
import FormViewer from '../../components/FormViewer'
import { translate } from '../../utils/useful'
import { siteTheme } from '../../variables/config'
import HttpServices from '../../utils/Http.services'

const colors = siteTheme.primaryColors

class SignUpUsernameStep extends React.Component {
    state = {
        isLoading: false,
        errors: {},
        usernameAvailable: null,
        formHeaders: [
            { key: 'username', type: 'TextInput', information: { label: '{{lang}}Username', icon: '/images/man.svg', placeholder: '{{lang}}Username', required: true } }
        ]
    }

    componentDidMount() {
        if (this.props.initData?.username) {
            this.checkUsername(this.props.initData.username)
        }
    }

    checkUsername = (username, onSuccess) => {
        if (!username || username.length < 3) {
            this.setState({ usernameAvailable: null, errors: { username: translate('Username must be at least 3 characters') } })
            return
        }

        this.setState({ isLoading: true, usernameAvailable: null })
        HttpServices.request('checkUsername', { username }, (result, error) => {
            this.setState({ isLoading: false })
            if (error) {
                this.setState({ 
                    usernameAvailable: false, 
                    errors: { username: error.message || translate('Username is not available') } 
                })
            } else {
                if (result && result.exists) {
                    this.setState({ 
                        usernameAvailable: false, 
                        errors: { username: translate('Username is already taken') } 
                    })
                } else {
                    this.setState({ usernameAvailable: true, errors: {} }, () => {
                        if (onSuccess) {
                            onSuccess(result)
                        }
                    })
                }
            }
        })
    }

    nextStep = () => {
        let data = this.form.getForm()

        if (!data || !data.username) {
            this.setState({ errors: { username: translate('Username is required') } })
            return
        }

        this.checkUsername(data.username, () => {
            this.props.setData(data, () => {
                if (this.props.stageManager) {
                    this.props.stageManager.nextStage()
                }
            })
        })
    }

    goBack = () => {
        if (this.props.stageManager) {
            this.props.stageManager.lastStage()
        }
    }

    render() {
        return (
            <div className="flexcc flex-column">
                <img className="mb-3" src={siteTheme.logo} width={'100px'} />
                <h2 className="mt-0 mb-2" style={{ fontSize: 24, color: colors.main1 }}>{translate('Choose Username')}</h2>
                <p className="mb-4" style={{ fontSize: 14, color: '#789', maxWidth: 400, textAlign: 'center' }}>{translate('Please choose a unique username for your account')}</p>

                <div className="w-100" style={{ maxWidth: 400 }}>
                    <FormViewer 
                        ref={el => this.form = el} 
                        headers={this.state.formHeaders} 
                        initData={this.props.initData} 
                        errors={this.state.errors} 
                        inputClass={'modern-input'}
                    />

                    {this.state.usernameAvailable === true && (
                        <div className="mt-2 mb-3" style={{ 
                            color: colors.main1, 
                            fontSize: 14,
                            padding: '8px 12px',
                            background: `${colors.main3}20`,
                            borderRadius: 8,
                            border: `1px solid ${colors.main3}40`
                        }}>
                            ✓ {translate('Username is available')}
                        </div>
                    )}

                    {this.state.usernameAvailable === false && (
                        <div className="mt-2 mb-3" style={{ color: '#FF3B30', fontSize: 14 }}>
                            ✗ {translate('Username is not available')}
                        </div>
                    )}

                    <div className="d-flex gap-3 justify-content-center align-items-center mt-4 mb-4 " style={{ flexWrap: 'wrap' }}>
                        <button
                        className='mx-2'
                            onClick={this.goBack}
                            style={{
                                background: `linear-gradient(135deg, ${colors.main3}50, ${colors.main3}60)`,
                                border: `2px solid ${colors.main3}80`,
                                borderRadius: 50,
                                padding: '12px 35px',
                                fontSize: 15,
                                fontWeight: 600,
                                color: colors.main1,
                                cursor: 'pointer',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                boxShadow: `0 2px 8px ${colors.main3}30`,
                                minWidth: 120,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 8
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = `linear-gradient(135deg, ${colors.main3}65, ${colors.main3}75)`
                                e.currentTarget.style.borderColor = colors.main3
                                e.currentTarget.style.transform = 'translateY(-2px)'
                                e.currentTarget.style.boxShadow = `0 4px 12px ${colors.main3}40`
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = `linear-gradient(135deg, ${colors.main3}50, ${colors.main3}60)`
                                e.currentTarget.style.borderColor = colors.main3 + '80'
                                e.currentTarget.style.transform = 'translateY(0)'
                                e.currentTarget.style.boxShadow = `0 2px 8px ${colors.main3}30`
                            }}
                        >
                            <span>←</span> {translate('Back')}
                        </button>
                        <LoaderButton
                            onClick={this.nextStep}
                            isLoading={this.state.isLoading}
                            text={translate('Next')}
                            type={"Oval"}
                            className="mt-0"
                            buttonStyle={{ 
                                outline: 'none', 
                                background: `linear-gradient(135deg, ${colors.main1} 0%, ${colors.main1} 75%, ${colors.main2} 100%)`,
                                cursor: this.state.isLoading ? 'wait' : 'pointer',
                                padding: '12px 50px', 
                                borderRadius: 50, 
                                fontSize: 15, 
                                fontWeight: 600, 
                                color: '#fff', 
                                border: 'none',
                                boxShadow: `0 4px 20px ${colors.main1}40, 0 2px 8px ${colors.main1}20`,
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                minWidth: 120
                            }}
                            width={80}
                            height={70}
                            color={'#fff'}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default SignUpUsernameStep

